import React, { useState, useEffect, useContext } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './input.css';
import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from "../../context/UtilContext";

const FechaSelector = ({ setDate, error = false, value = null }) => {
    const [fecha, setFecha] = useState(!value ? value : null);
    const [fechafinal, setFechafinal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

    const toggleCalendar = () => setIsOpen(!isOpen);

    // Obtener el año actual
    const currentYear = new Date().getFullYear();

    // Función para formatear la fecha
    const formatFecha = (fecha) => {
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, '0'); // Se suma 1 al mes porque los meses empiezan desde 0
        const day = String(fecha.getDate()).padStart(2, '0'); // Asegura que el día tenga dos dígitos

        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (fecha) {
            const formattedDate = formatFecha(fecha);
            setDate(formattedDate); // Actualiza fechafinal con el valor formateado
        }
    }, [fecha]); // Se ejecuta cada vez que `fecha` cambie

    return (
        <div className="fecha-selector">
            {!isOpen && value == null && (
                <div onClick={toggleCalendar} className={` ${error ? `custom-date-display-error` : `custom-date-display`} `}>
                    {fecha ? fecha.toLocaleDateString() : t.input_date.placeholder}
                </div>
            )}
            {!isOpen && value != null && (
                <div onClick={toggleCalendar} className={` ${error ? `custom-date-display-error` : `custom-date-display`} `}>
                    {fecha ? fecha.toLocaleDateString() : value}
                </div>
            )}
            {console.log("isOpen", value)
            }
            {isOpen && (
                <DatePicker
                    selected={fecha}
                    onChange={(date) => {
                        setFecha(date);
                        setIsOpen(false); // Cierra el calendario al seleccionar la fecha
                    }}
                    error={error}
                    inline

                    calendarClassName="custom-datepicker-calendar"
                    dateFormat="dd/MM/yyyy"
                    showYearDropdown // Habilita el selector de año
                    showMonthDropdown // Habilita el selector de mes
                    scrollableYearDropdown // Permite un menú desplegable de años desplazable
                    yearDropdownItemNumber={100} // Número de años visibles en el dropdown
                    minDate={new Date(currentYear - 100, 0, 1)} // Muestra fechas desde el año 100 años atrás
                    maxDate={new Date(currentYear, 11, 31)} // Limita la selección a la fecha actual 
                />
            )}
        </div>
    );
};

export default FechaSelector;
